export default __webpack_public_path__ + "static/media/EOS.c39a34fe.svg";